var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "emd-container" }, [
    _c(
      "div",
      { staticClass: "eu emd-container__header eu-py_4_md eu-px_5_md" },
      [
        _c("div", { staticClass: "eu-basis_6 eu-basis_4_md" }, [
          _c(
            "div",
            { staticClass: "eu-flex eu-flex-item eu-basis_12 eu-basis_12_md" },
            [
              _vm.collapse
                ? _c(
                    "a",
                    {
                      staticClass: "emd-input-icon__link collapse-icon ",
                      on: {
                        click: function ($event) {
                          _vm.showContent = !_vm.showContent
                        },
                      },
                    },
                    [
                      _vm.showContent
                        ? _c("i", { staticClass: "uil uil-angle-down" })
                        : _c("i", { staticClass: "uil uil-angle-right" }),
                    ]
                  )
                : _vm._e(),
              _c(
                "h2",
                {
                  staticClass:
                    "emd-text _size_section _color_default padding-title",
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "eu-flex-item eu-basis_12 eu-basis_12_md" },
            [_vm._t("subtitle")],
            2
          ),
        ]),
        _c(
          "div",
          {
            staticClass:
              "eu-flex eu-justify_end _align-end eu-basis_6 eu-basis_2_md",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "eu-flex-item eu-basis_6 eu-basis_3_md eu-flex eu-justify_end padding-icon",
              },
              [_vm._t("icon")],
              2
            ),
          ]
        ),
      ]
    ),
    _c(
      "div",
      [
        _c("hr", { staticClass: "emd-divider" }),
        !_vm.summary && (!_vm.collapse || _vm.showContent)
          ? _c(
              "div",
              { staticClass: "emd-container__content eu-pa_5_md" },
              [!_vm.collapse || _vm.showContent ? _vm._t("content") : _vm._e()],
              2
            )
          : _vm._e(),
        !_vm.collapse || _vm.showContent ? _vm._t("summary") : _vm._e(),
        _vm._t("footer"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }